import React from 'react';

import Grid from './Grid';
import Container from './Container';

import './styles/style.scss';

export default Grid;

export { default as Container } from './Container';
export { default as GridCol } from './GridCol';

export const TextContainer = props => <Container type="text" {...props} />;



// WEBPACK FOOTER //
// ./src/components/Grid/index.js